import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { govPageContainer, GOV_TYPE } from '../ui/PatientUIGovernor';
import DoctorLabOrders from '../components/DoctorLabOrders';
import ImagingOrders from '../components/ImagingOrders';

/**
 * Imaging & Diagnostics — the patient's REAL imaging orders
 * (`GET /imaging/orders`), placed by a doctor or hospital and progressed by
 * the imaging centre.
 *
 * This page used to keep its own list in the browser: an inline form wrote a
 * "booking" into localStorage at a free-typed centre, and Cancel just flipped
 * that local row. No imaging centre ever saw any of it, and the real orders a
 * hospital had placed were not shown at all.
 *
 * The order list now lives in `components/ImagingOrders` so that this page and
 * Care Services → Imaging show one thing rather than two different ones.
 */
export default function PatientDiagnostics() {
  const navigate = useNavigate();

  return (
    <div style={{ ...govPageContainer(), display: 'flex', flexDirection: 'column', gap: 14 }}>

      <div>
        <h1 style={{ ...GOV_TYPE.pageTitle }}>Imaging &amp; Diagnostics</h1>
        <p style={{ fontSize: 11, color: T.textSec, marginTop: 4, fontFamily: T.font }}>
          Studies your doctor or hospital ordered, and the reports released to you
        </p>
      </div>

      {/* Lab tests a doctor ordered live here too: this is where a patient
          comes to see what has been asked of them, and they had no other
          surface at all. */}
      <DoctorLabOrders />

      <ImagingOrders />

      {/* Imaging is not booked by a patient on this platform, so this points at
          the centre directory rather than promising a booking. The button here
          used to say "Book Imaging at a Listed Centre" and led to a flow the
          server refused with a 422 every time. */}
      <button
        onClick={() => navigate('/patient/care-services/imaging')}
        style={{
          width: '100%',
          padding: '12px 0',
          fontSize: 13,
          fontWeight: 700,
          fontFamily: T.font,
          color: T.teal,
          background: T.white,
          border: `1.5px solid ${T.teal}`,
          borderRadius: 12,
          cursor: 'pointer',
        }}
      >
        Find an imaging centre
      </button>

      <div style={{
        background: `${T.teal}06`, border: `1px solid ${T.teal}18`, borderRadius: 12,
        padding: 12, fontSize: 9, color: T.textSec, lineHeight: 1.6, textAlign: 'center', fontFamily: T.font,
      }}>
        Imaging is ordered by your doctor or hospital, so an order cannot be cancelled from here — ask the centre that holds it.
      </div>
    </div>
  );
}
